// extracted by mini-css-extract-plugin
module.exports = {"panelTitle":"preference_panelTitle__wfVX5","noBorder":"preference_noBorder__tz7sE","select":"preference_select__aQjDg"};